<template>
    <div v-loading.fullscreen="loading">
        <div v-if="!loading">
            <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'documentList' }">Documents</el-breadcrumb-item>
                <el-breadcrumb-item
                    v-if="editing && model"
                    :to="{ name: 'documentShow', params: { id: model.id } }"
                >{{ model.name }}</el-breadcrumb-item>
                <el-breadcrumb-item v-if="editing">{{$t('table.edit')}}</el-breadcrumb-item>
                <el-breadcrumb-item v-if="!editing">{{$t('table.add')}}</el-breadcrumb-item>
            </el-breadcrumb>

            <h2 class="page-title">{{ editing ? $t('table.edit') + ' Document': $t('table.add') + ' Document' }}</h2>

            <el-form
                ref="form"
                :model="model"
                :label-position="labelPosition"
                :label-width="labelWidth"
                :rules="rules"
                @submit.native.prevent="save"
            >
                <div class="block">
                    <el-form-item label="Name" prop="name">
                        <el-col :lg="11" :md="16" :sm="24">
                            <el-input v-model="model.name" ref="focus"/>
                        </el-col>
                    </el-form-item>
              
                  
                    <!-- Document -->
                    <el-form-item label="Documents"  prop="attachments">
                        <el-col :lg="11" :md="16" :sm="24">

                              <app-file-upload
                                :stored="model.attachments"
                                :max="1"
                                :size="1000000"
                                :formats="['pdf']"
                                ref="attachments"
                                />
                            <!-- <input type="file" id="document" ref="document" v-on:change="handleFileUpload()"/>       -->
                        </el-col>
                       
                    </el-form-item>
                    <!-- Document -->

                </div>

                <div class="button-group mt-3">
                    <el-button
                        @click="save()"
                        :disabled="loading"
                        type="primary"
                        icon="el-icon-fa-floppy-o"
                    >Save</el-button>
                    <el-button @click="back()" :disabled="loading" icon="el-icon-fa-times">Cancel</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import validators from "@/shared/form/validators";
import myUpload from 'vue-image-crop-upload';
// import _ from "underscore"
 /* eslint-disable */ 
export default {
    name: "app-document-form",
    components: {   
        'my-upload': myUpload
    },
    props: {
        id: String,
        previous: String
    },

    data() {
        return {
            show: false,
            documentList: [],
            rules: {
                name: validators.string({
                    label: "Name",
                    required: true
                }),
                attachments: validators.hasOne({
                    label: "Document",
                    required: true
                })
            }
        };
    },

    created() {
        this.$store.dispatch("entities/document/loadOptions");
        if (this.id) {
            this.$store
                .dispatch("entities/document/edit", this.id)
                .catch(() => this.$router.push({ name: "documentList" }));
        } else {
            this.$store.dispatch("entities/document/new");
        }
    },

    beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/document/clear");
        next();
    },

    computed: {
        ...mapGetters({
            model: "entities/document/model",
            loading: "entities/document/loading",
            labelPosition: "shared/labelPosition",
            labelWidth: "shared/labelWidth",
            options: "entities/document/options"
        }),

        editing: state => !!state.id
    },

    methods: {
        save() {
            this.$refs.form.validate().then(valid => {
                if (!valid) {
                    return;
                }
                
                if (this.atachDocument()) {
                    this.$store.dispatch("entities/document/save", this.model).then((model) => {
                        this.back();
                    });
                }
            });
        },

        back() {
            if (this.previous === "show") {
                this.$router.push({
                    name: "documentShow",
                    params: { id: this.id }
                });
                return;
            }

            this.$router.push({ name: "documentList" });
        },

        atachDocument() {
            this.model.attachments = this.$refs.attachments.data || [];

            console.log(this.model.attachments.length);
            
            if (this.model.attachments.length == 0 ) {
                console.log("false");
                
                return false
            } else {
                console.log("true");

                return true
            }
        },

        toggleShow() {
            this.show = !this.show;
        },
    }
};
</script>


<style>
  .team-uploader{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
  }
  .team-uploader:hover {
    border-color: #409EFF;
  }
  .team-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/entities/document/document-form.vue?614a65e2